import { 
    ASSIGN_PERMISSION_TO_ROLE_REQUEST,
    ASSIGN_PERMISSION_TO_ROLE_SUCCESS,
    ASSIGN_PERMISSION_TO_ROLE_FAILURE,
    CLEAR_PERMISSION_ASSIGNMENT_ERROR,
    FETCH_ASSIGNED_PERMISSIONS_REQUEST,
    FETCH_ASSIGNED_PERMISSIONS_SUCCESS,
    FETCH_ASSIGNED_PERMISSIONS_FAILURE,
    CLEAR_ASSIGNED_PERMISSIONS_FETCHING_ERROR,
    FETCH_ALL_PERMISSIONS_REQUEST,
    FETCH_ALL_PERMISSIONS_SUCCESS,
    FETCH_ALL_PERMISSIONS_FAILURE,
    CLEAR_PERMISSIONS_FETCHING_ERROR,
    FETCH_ALL_PERMISSION_CATEGORIES_REQUEST,
    FETCH_ALL_PERMISSION_CATEGORIES_SUCCESS,
    FETCH_ALL_PERMISSION_CATEGORIES_FAILURE,
    CLEAR_PERMISSION_CATEGORIES_FETCHING_ERROR,
    FETCH_ROLE_PERMISSIONS_REQUEST,
    FETCH_ROLE_PERMISSIONS_SUCCESS,
    FETCH_ROLE_PERMISSIONS_FAILURE,
    CLEAR_ROLE_PERMISSIONS_FETCHING_ERROR,
    REMOVE_PERMISSION_FROM_ROLE_REQUEST,
    REMOVE_PERMISSION_FROM_ROLE_SUCCESS,
    REMOVE_PERMISSION_FROM_ROLE_FAILURE,
    // CLEAR_PERMISSION_REMOVAL_ERROR
} from "../actions/rolePermissionActionTypes";



const initialState = {
    permissions: {
        data: [],
        loading: false,
        error: null,
    },
    permissionCategories: {
        data: [],
        loading: false,
        error: null,
    },
    rolePermissions: {
        data: [],
        loading: false,
        error: null,
    },
    assignPermission: {
        loading: false,
        success: null,
        error: null,
    },
    assignedPermissions: {
        data: [],
        loading: false,
        error: null,
    },
};



const rolePermissionReducer = (state = initialState, action) => {
    switch (action.type) {

        // Case for handling request to assign permission to role
        case ASSIGN_PERMISSION_TO_ROLE_REQUEST:
            return {
                ...state,
                assignPermission: {
                    loading: true,
                    success: null,
                    error: null,
                },
            };


        // Case for handling successful assignment of permission to role
        case ASSIGN_PERMISSION_TO_ROLE_SUCCESS:
                return {
                    ...state,
                    assignPermission: {
                        loading: false,
                        success: action.payload,
                        error: null,
                    },
                };


        // Case for handling failure to assign permission to role
        case ASSIGN_PERMISSION_TO_ROLE_FAILURE:
            return {
                ...state,
                assignPermission: {
                    loading: false,
                    success: null,
                    error: action.payload,
                },
            };


        // Case to handle clearing of permission assignment errors that might occur
        case CLEAR_PERMISSION_ASSIGNMENT_ERROR:
            return {
                ...state, 
                assignPermission: {
                    ...state.assignPermission,
                    error: null,
                },
            };


        // Case for handling the request to fetch all permissions
        case FETCH_ALL_PERMISSIONS_REQUEST:
            return {
                ...state,
                permissions: {
                    ...state.permissions,
                    loading: true,
                    error: null,
                },
            };


        // Case for handling successful fetching of all permissions
        case FETCH_ALL_PERMISSIONS_SUCCESS: 
            return {
                ...state,
                permissions: {
                    ...state.permissions,
                    loading: false,
                    data: action.payload,
                },
            };


        // Case for handling failure to fetch all permissions
        case FETCH_ALL_PERMISSIONS_FAILURE: 
            return {
                ...state,
                permissions: {
                    ...state.permissions,
                    loading: false,
                    error: action.payload,
                },
            };


        // Case to clear permissions fetching error
        case CLEAR_PERMISSIONS_FETCHING_ERROR: 
            return {
                ...state,
                permissions: {
                    ...state.permissions,
                    error: null,
                },
            };


        // Case for handling the request to fetch permissions assigned to a role
        case FETCH_ASSIGNED_PERMISSIONS_REQUEST:
            return {
                ...state,
                assignedPermissions: {
                    ...state.assignedPermissions,
                    loading: true,
                    error: null,
                },
            };


        // Case for handling the successful fetching of permissions assigned to a role
        case FETCH_ASSIGNED_PERMISSIONS_SUCCESS:
            return {
                ...state,
                assignedPermissions: {
                    loading: false,
                    data: action.payload,
                },
            };


        // Case for handling failure to fetch permissions assigned to a role
        case FETCH_ASSIGNED_PERMISSIONS_FAILURE:
            return {
                ...state,
                assignedPermissions: {
                    loading: false,
                    error: action.payload,
                },
            };


        // Case to clear assigned permissions fetching errors
        case CLEAR_ASSIGNED_PERMISSIONS_FETCHING_ERROR: 
            return {
                ...state,
                assignedPermissions: {
                    ...state.assignedPermissions,
                    error: null,
                },
            };
            

        // Case for handling request to fetch all permission categories
        case FETCH_ALL_PERMISSION_CATEGORIES_REQUEST: 
            return {
                ...state,
                permissionCategories: {
                    ...state.permissionCategories,
                    loading: true,
                    error: null,
                },
            };


        // Case for handling successful fetching of all permission categories
        case FETCH_ALL_PERMISSION_CATEGORIES_SUCCESS: 
            return {
                ...state,
                permissionCategories: {
                    ...state.permissionCategories,
                    loading: false,
                    data: action.payload,
                },
            };
            

        // Case for handling failure to fetch all permission categories
        case FETCH_ALL_PERMISSION_CATEGORIES_FAILURE: 
            return {
                ...state,
                permissionCategories: {
                    ...state.permissionCategories,
                    loading: false,
                    error: action.payload,
                },
            };


        // Case to clear permission categories errors
        case CLEAR_PERMISSION_CATEGORIES_FETCHING_ERROR: 
            return {
                ...state,
                permissionCategories: {
                    ...state.permissionCategories,
                    error: null,
                },
            };


        // Case for handling request to fetch role permissions
        case FETCH_ROLE_PERMISSIONS_REQUEST: 
            return {
                ...state,
                rolePermissions: {
                    ...state.rolePermissions,
                    loading: true,
                    error: null,
                },
            };


        // Case for handling successful fetching of role permissions
        case FETCH_ROLE_PERMISSIONS_SUCCESS: 
            return {
                ...state,
                rolePermissions: {
                    ...state.rolePermissions,
                    loading: false,
                    data: action.payload,
                },
            };


        // Case for handling failure to fetch role permissions
        case FETCH_ROLE_PERMISSIONS_FAILURE: 
            return {
                ...state,
                rolePermissions: {
                    ...state.rolePermissions,
                    loading: false,
                    error: action.payload,
                },
            };


        // Case to clear role permissions errors
        case CLEAR_ROLE_PERMISSIONS_FETCHING_ERROR: 
            return {
                ...state,
                rolePermissions: {
                    ...state.rolePermissions,
                    error: null,
                },
            };



        // Case for handling request to remove a permission from a role
        case REMOVE_PERMISSION_FROM_ROLE_REQUEST:
            return {
                ...state,
                loading: true,
            };



        // Case for handling successful removal of a permission from a role
        case REMOVE_PERMISSION_FROM_ROLE_SUCCESS:
            return {
                ...state,
                loading: false,
                assignedPermissions: state.assignedPermissions.filter(
                    (permission) => permission.id !== action.payload
                ),
            };



        // Case for handling failure to remove a permission from a role
        case REMOVE_PERMISSION_FROM_ROLE_FAILURE: 
            return {
                ...state,
                loading: false,
                error: action.payload,
            };


            // If none is applicable, return the state
            default:
                return state;

    }
};


export default rolePermissionReducer;